import React from 'react';
import dynamic from 'next/dynamic';
import { getChartAdapter } from '@/components/widget/visualizations/chartAdapters';
import chartList from '@/features/resources/chartBuilderSettings';
import Loading from './Loading';
import styles from './styles.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";

const ChartsSwitcher = _ref => {
  let {
    onChartSelect
  } = _ref;
  return /*#__PURE__*/_jsx("ul", {
    className: styles.list,
    children: chartList.map(chart => {
      return /*#__PURE__*/_jsx("li", {
        className: styles.item,
        children: /*#__PURE__*/_jsx("button", {
          type: "button",
          className: styles.icon,
          onClick: () => {
            const chartAdapter = getChartAdapter(chart.chartAdapterType);

            if (typeof chartAdapter === 'function') {
              onChartSelect(chartAdapter, chart);
            }
          },
          children: /*#__PURE__*/_jsx("img", {
            src: chart.icon,
            alt: chart.images.resourceUrlAlt
          })
        })
      }, chart.slug);
    })
  });
};

export default dynamic(() => Promise.resolve(ChartsSwitcher), {
  ssr: false,
  loading: () => /*#__PURE__*/_jsx(Loading, {})
});